import FilterModule from '~/store/filter';
import ManageMedia from '~/api/manage_media';

let searchMediaPromise = null;

export default {
    namespaced: true,
    state: FilterModule.state({
        page: 1,
        page_size: 18,
        search: null,
        sort: "newest",
        type: null,
        type_system_name: null,
        status: null,
        tags: [],
        folders: [],
        is_base: null,
        type_id: null,
        template_type: null
    }),
    mutations: FilterModule.mutations,
    actions: {
        async getData({commit, state}, payload) {
            if (searchMediaPromise) {
                searchMediaPromise.abort();
            }
            commit('updateIsLoading', true);
            searchMediaPromise = ManageMedia.searchMedia(state.params);
            const media = await searchMediaPromise;
            commit('updateMeta', media);
            commit('updateIsLoading', false);
            searchMediaPromise = null;
            return media;
        }
    }
}